var map = {
	"./souvenir0.svg": 84284,
	"./souvenir1.svg": 91112,
	"./souvenir10.svg": 27186,
	"./souvenir11.svg": 36114,
	"./souvenir2.svg": 23443,
	"./souvenir3.svg": 73936,
	"./souvenir4.svg": 70971,
	"./souvenir5.svg": 21018,
	"./souvenir6.svg": 18080,
	"./souvenir7.svg": 61247,
	"./souvenir8.svg": 81741,
	"./souvenir9.svg": 21237
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 54945;